/* ------------------------------------------------------------------
   Ergaenzt die Trackingseite der App um den erklaerenden Satz unter der
   Ueberschrift. Die App baut ihr Formular selbst per JavaScript, der
   Container ist beim ersten Durchlauf also meist noch leer. Deshalb
   versuchen wir es sofort und danach ueber einen Beobachter, bis das
   Formular steht. Nach zehn Sekunden geben wir auf, damit nichts
   dauerhaft mitlaeuft.

   Zur Raute: Shopify vergibt die Bestellnamen mit Raute, im Shop laufen
   sie als #1024 und so stehen sie auch in der Bestaetigungsmail. Die App
   reicht die Eingabe unveraendert weiter, die Raute wird also nicht
   abgeschnitten. Deshalb nennt der Satz sie ausdruecklich.
   ------------------------------------------------------------------ */
(function () {
  var fertig = false;

  var einleitung =
    '<p class="mp-track__sub">Geben Sie Ihre Bestellnummer und die E-Mail-Adresse aus der ' +
    'Bestellung ein. Die Bestellnummer steht in der Bestätigungsmail und beginnt mit einer ' +
    'Raute, zum Beispiel <b>#1234</b>.</p>';

  function einhaengen() {
    if (fertig) return true;
    var seite = document.getElementById('pp-tracking-page-app');
    if (!seite) return false;
    var titel = seite.querySelector('.pp_tracking_title');
    if (!titel) return false;

    fertig = true;
    titel.insertAdjacentHTML('afterend', einleitung);
    return true;
  }

  if (!einhaengen()) {
    var beobachter = new MutationObserver(function () {
      if (einhaengen()) beobachter.disconnect();
    });
    beobachter.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { beobachter.disconnect(); }, 10000);
  }
})();
